import { Pipe, PipeTransform } from '@angular/core';
import { UsersLicensPermissions } from '@account-users/account/models/LicensePermissionList';

@Pipe({
  name: 'licensesSelected',
})
export class LicensesSelectedPipe implements PipeTransform {
  transform(
    selectedLiceses: string[],
    permissions: UsersLicensPermissions[] = [],
  ): UsersLicensPermissions[] {
    let array = [];
    if (selectedLiceses && selectedLiceses.length) {
      selectedLiceses.forEach((l) => {
        array = [...array, ...[permissions.find((p) => p.code === l)]];
      });
    }
    return array;
  }
}
